import NoPaymentSessionDataFoundError from "@/entities/errors/noPaymentSessionDataFoundError";
import IPaymentRequiredData from "@/interfaces/iPaymentRequiredData";
import PaymentRequiredAction from "@/interfaces/paymentRequiredAction";
import { IVendible, IVendibleApiClient, VendibleType } from "@cyber-range/cyber-range-api-payment-client";
import IPaymentProcessor from "./iPaymentProcessor";
import OrganizationBalancePaymentProcessor from "./organizationBalancePaymentProcessor";
import UserPaymentProcessor from "./userPaymentProcessor";
import { useApiClientStore } from "../../stores/apiClientStore";
import { usePaymentStore } from "../../stores/paymentStore";

export default class PaymentProcessorFactory {
    static async create(vendibleId: string): Promise<IPaymentProcessor> {
        const data: IPaymentRequiredData = usePaymentStore().requiredPaymentData[vendibleId];

        if (!data)
        {
            const vendibleApiClient: IVendibleApiClient = useApiClientStore().vendibleApiClient;
            let vendible: IVendible;
            try
            {
                vendible = await vendibleApiClient.getOne(vendibleId);
            } catch (error) {}

            if (vendible?.type === VendibleType.OrganizationBalance)
            {
                return new OrganizationBalancePaymentProcessor(vendible);
            }
        }
        else if (data.source.action === PaymentRequiredAction.UserCreation)
        {
            return new UserPaymentProcessor(data);
        }

        throw new NoPaymentSessionDataFoundError();
    }
}
